var HOST = {
  HELP_PAY: 'https://help.pay.naver.com',
  HELP_NAVER: 'https://help.naver.com'
};
var URL = {
  HELP: "".concat(HOST.HELP_PAY, "/mail/form.help"),
  PC_VERSION: 'https://pay.naver.com/about?site_preference=normal',
  ALL_SERVICES: {
    // 전체서비스
    PC: 'https://www.naver.com/more.html',
    MOBILE: 'https://m.naver.com/services.html'
  },
  SHOPPING_PAY_HELP: "".concat(HOST.HELP_PAY, "/index.help"),
  TERMS_POLICY: '/member/terms-policy',
  PRIVACY: '/member/terms-policy/privacy',
  CREDIT_INFO_USAGE: '/member/terms-policy/credit-info-usage',
  NPAY_AD_POINT: 'https://npayad.naver.com',
  LOAN_SOLICITATION_TERMS: '/member/terms-policy/loan-solicitation',
  SAVINGS_INTEREST_RATE_INFO: "".concat(HOST.HELP_PAY, "/faq/content.help?faqId=13359"),
  STOCK: {
    NOTICE: '/notice',
    HELP: "".concat(HOST.HELP_NAVER, "/alias/contents2/finance/finance_1.naver"),
    ERROR_REPORT: "".concat(HOST.HELP_NAVER, "/inquiry/input.help?categoryNo=5484&serviceNo=5617") // 증권 오류신고
  },
  STOCK_LOCAL_NEWS: {
    TERMS_POLICY: 'https://policy.naver.com/policy-mobile/term.html?type=1',
    PRIVACY: 'https://policy.naver.com/policy-mobile/privacy.html' // 네이버 개인정보처리방침
  },
  NAVER_FINANCIAL_TERMS_POLICY: '/member/terms-policy/naver-financial-service',
  REAL_ESTATE_HELP: "".concat(HOST.HELP_NAVER, "/alias/land/landmain.naver"),
  NAVER_FINANCIAL: 'https://www.naverfincorp.com/main',
  REAL_ESTATE_OPEN_SOURCE_LICENSE: '/licenses',
  REAL_ESTATE_INSURANCE_HELP: "".concat(HOST.HELP_NAVER, "/alias/land/land_75.naver"),
  REAL_ESTATE_COMPLEX_EDIT_SUGGESTION: 'https://cityplan.rsun.kr:442/naver/danji/mobile_danji_report.asp',
  REAL_ESTATE_COMPLEX_NEW_REQUEST: 'https://cityplan.rsun.kr:442/naver/danji/mobile_danji_regist.asp' // 단지정보 신규 요청
};
var NAVER_MAIN_URL = {
  PC: 'https://naver.com/',
  MOBILE: 'https://m.naver.com/'
};

export { NAVER_MAIN_URL, URL };
